<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='800px'>
    <el-form v-loading='formLoading' :model='form' label-width='140px' label-position='right'
             ref='ruleForm'>
      <div-border label='基本信息' class='p20'>
        <el-row :gutter='10'>
          <el-col :span='24'>
            <el-form-item label='委托商：'>
              <span>{{ form.customerName |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='合同名称：'>
              <span>{{ form.contractName |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='合同编号：'>
              <span>{{ form.contractCode |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='结算类型：'>
              <span>{{ form.settlementType |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='港口/库房名称：'>
              <span>{{ form.name |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='品牌'>
              <span>{{ form.brands |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='作业类型：'>
              <span>{{ form.taskType |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='有效期始：'>
              <span>{{ form.startDate |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='结束日期：'>
              <span>{{ form.endDate |valFormat }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div-border>
      <div-border label='价格信息' class='p20'>
        <el-row :gutter='10'>
          <el-col :span='24'>
            <el-form-item label='税率：'>
              <span>{{ form.taxRate |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='8'>
            <el-form-item label='合同价：'>
              <span>{{ form.contractPrice |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='8'>
            <el-form-item label='预结算价：'>
              <span>{{ form.preparePrice |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='8'>
            <el-form-item label='预估价：'>
              <span>{{ form.estimatePrice |valFormat }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div-border>
      <div-border label='补录合同' class='p20'>
        <el-table
          ref='registerTable'
          row-key='id'
          :data='contractData'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
        >

          <el-table-column type='index' label='序号' width='50' align='center'></el-table-column>
          <el-table-column property='codeNumber' label='合同编号' min-width='150' align='center' />
          <el-table-column property='contractName' label='合同名称' min-width='150' align='center' />
          <el-table-column property='typeName' label='合同类型' min-width='100' align='center' />
          <el-table-column prop='supplementaryContract.rate' label='税率' min-width='150' align='center' />
          <el-table-column prop='supplementaryContract.taxContractPrice' label='含税合同价' min-width='150' align='center' />
          <el-table-column prop='supplementaryContract.contractPrice' label='不含税合同价' min-width='150' align='center' />
          <el-table-column property='startDate' label='开始日期' min-width='100' :formatter='getDate'
                           align='center' />
          <el-table-column property='endDate' label='结束日期' min-width='100' :formatter='getDate'
                           align='center' />
          <el-table-column width='200px' label='操作' align='center' fixed='right'>
            <template slot-scope='scope'>
              <el-button type='danger' size='small' @click='deleteTableClick(scope.row)'>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div-border>
      <div-border label='操作记录' class='p20'>
        <el-table
          ref='registerTable'
          row-key='id'
          :data='form.operateRecordList'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
        >
          <el-table-column prop='createTime' label='操作时间' align='center' width='160px' />
          <el-table-column prop='operateType' label='操作类型' align='center' />
          <el-table-column prop='operationName' label='操作人' align='center' />
          <el-table-column prop='remark' label='备注' align='center' />
        </el-table>
      </div-border>

      <div class='flex-center-center mt10 '>
        <el-button size='medium' class='searchBtn' @click='dialogClose'>确认</el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import divBorder from '@/components/divBorder.vue';
  import { portWarehouseConsignorPriceSettingDetail } from '@/service/warehouse';
  import {deleteContractInfo, getContractInfo} from "@/service/financial";

  export default {
    name: 'harborWarehouseIncomePriceSettingInfo',
    components: { divBorder },
    data() {
      return {
        dialogTitle: '详情',
        dialogVisible: false,
        defaultForm: {},
        contractData: [],
        form: {},
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        formLoading: false,
      };
    },
    filters: {
      valFormat(str) {
        if (str) {
          return str;
        } else {
          return '无';
        }
      },
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      dialogOpen(id) {
        this.dialogVisible = true;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.getDetails(id);
      },
      dialogClose() {
        this.dialogVisible = false;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
      },
      async getDetails(id) {
        this.formLoading = true;
        const {
          status,
          message,
          data,
        } = await portWarehouseConsignorPriceSettingDetail(id);
        this.formLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.form = data;
       let res1 = await getContractInfo(id);
        if (res1.status !== 0) return this.$message.warning(res1.message);
        this.contractData = res1.data
      },
      //详情-补录合同-删除
      deleteTableClick(row){
        this.$confirm('确认删除当前合同吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let obj = {
              priceInfoId: row.supplementaryContract.priceInfoId,
              contractId: row.supplementaryContract.contractId,
              type: 2,
            }
            const res = await deleteContractInfo(obj);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.dialogVisible = false
          })
      },
      // 时间长度处理
      getDate(row, column, cellValue) {
        if (cellValue) {
          return cellValue.substring(0, 10);
        } else {
          return '';
        }
      },
    },
  };
</script>

<style lang='scss' scoped>
  ::v-deep {
    .el-form-item {
      margin-bottom: 0;
    }
  }
</style>
